import search from './search'
import ingredients from './ingredients'
import favoriteButton from './favoriteButton'
import swiper from './swiper'
import counter from './counter'
import numericInputButton from './numericInputButton'
import commentList from './comment-list'
import commentForm from './comment-form'
import starSelector from './star-selector'
import singletonModal from './singleton-modal'
import recipeContent from './bk-content'

export default {
	search,
	ingredients,
	favoriteButton,
	swiper,
	counter,
	numericInputButton,
	commentList,
	commentForm,
	starSelector,
	singletonModal,
	recipeContent,
}
